import { SearchResult } from './SearchResult';
import { HotelRegion } from './Hotel';

export interface SearchHotelInterface extends SearchResult {
    id: string;
    region: HotelRegion;
    name: string;
    type: string;
}

export class SearchHotel implements SearchHotelInterface {
    public id: string;
    public region: HotelRegion;
    public name: string;
    public type: string;

    constructor(i: SearchHotelInterface) {
        this.id = i.id;
        this.region = i.region;
        this.name = i.name;
        this.type = 'hotel';
    }

    public getFullName() {
        return `${this.name}${!!this.region && !!this.region.name ? ', ' + this.region.name : ''}`;
    }
}



// WEBPACK FOOTER //
// ./src/models/Hotels/SearchHotel.ts